export default __webpack_public_path__ + "static/media/proj2_5.fbc2e7d0.jpg";